/**
 * Utility to replace all placeholders in template texts
 */

// Assinatura do fim dos textos. Por padrão é o nome da conta; aqui fica a assinatura
// completa de quem tem nome curto na conta (Adnéia, 16/10/2026). O nome da conta não
// muda: ele está gravado como "atendente" em cada chamado e a lista filtra por ele.
const ASSINATURA_POR_EMAIL = {
  'gabriela@weconnect360.com.br': 'Gabriela Gonzaga',
};

export const assinaturaDoUsuario = (user) =>
  ASSINATURA_POR_EMAIL[(user?.email || '').toLowerCase()] || user?.name || '';

export const replaceAllPlaceholders = (texto, context = {}) => {
  if (!texto) return '';

  const { user, formData, pedidoErp, codigoReversa, dataVencimentoReversa, awbTotal, jmsJt } = context;

  let result = texto;

  // [CUMPRIMENTO] fora do montarTexto: nunca sai cru (vai a versão do canal, só com a hora)
  if (result.includes('[CUMPRIMENTO]')) {
    result = result.replace(/\[CUMPRIMENTO\]/g, montarCumprimento({ para: 'canal' }));
  }

  // [ASSINATURA]
  const assinatura = assinaturaDoUsuario(user) || formData?.atendente;
  if (assinatura) {
    result = result.replace(/\[ASSINATURA\]/g, assinatura);
  }

  // [NOME_CLIENTE] and [NOME]
  if (pedidoErp?.nome_cliente) {
    result = result.replace(/\[NOME_CLIENTE\]/g, pedidoErp.nome_cliente);
    result = result.replace(/\[NOME\]/g, pedidoErp.nome_cliente);
    const primeiroNome = pedidoErp.nome_cliente.split(' ')[0];
    result = result.replace(/\[PRIMEIRO_NOME\]/g, primeiroNome);
  }

  // [PARCEIRO]
  if (formData?.parceiro) {
    result = result.replace(/\[PARCEIRO\]/g, formData.parceiro);
  }

  // [PRODUTO]
  if (pedidoErp?.produto) {
    result = result.replace(/\[PRODUTO\]/g, pedidoErp.produto);
  }

  // [ITENS_ENTREGA] — TODOS os itens da entrega (ex.: "Produto A, Produto B e Produto C")
  // Usado em entrega parcial. Fallback para o produto único quando a lista não veio.
  {
    const lista = Array.isArray(pedidoErp?.itens_entrega) && pedidoErp.itens_entrega.length
      ? pedidoErp.itens_entrega
      : (pedidoErp?.produto ? [pedidoErp.produto] : []);
    let itensTexto = '[ITENS DA ENTREGA]';
    if (lista.length === 1) {
      itensTexto = lista[0];
    } else if (lista.length > 1) {
      itensTexto = lista.slice(0, -1).join(', ') + ' e ' + lista[lista.length - 1];
    }
    result = result.replace(/\[ITENS_ENTREGA\]/g, itensTexto);
  }

  // [ENTREGA] — sempre o número da entrega (numero_pedido), em todos os canais.
  // (O pedido externo LLL-xxxxx da LL Loyalty NÃO deve ser usado aqui.)
  const entrega = pedidoErp?.numero_pedido || formData?.numero_pedido;
  if (entrega) {
    result = result.replace(/\[ENTREGA\]/g, entrega);
  }

  // [NOTA_FISCAL]
  if (pedidoErp?.nota_fiscal) {
    const nfLimpa = String(pedidoErp.nota_fiscal).split('.')[0];
    result = result.replace(/\[NOTA_FISCAL\]/g, nfLimpa);
  }

  // [CHAVE_ACESSO]
  if (pedidoErp?.chave_nota) {
    result = result.replace(/\[CHAVE_ACESSO\]/g, pedidoErp.chave_nota);
  }

  // [CÓDIGO_RASTREIO] — usa AWB da Base Total ou JMS da J&T como fallback quando não há rastreio no tabelão
  const codigoRastreio = pedidoErp?.codigo_rastreio || awbTotal?.awb || jmsJt?.jms || '';
  result = result.replace(/\[CÓDIGO_RASTREIO\]/g, codigoRastreio);

  // [DATA_ENTREGA] and [DATA_ULTIMO_PONTO]
  if (pedidoErp?.data_status) {
    let dataFormatada = pedidoErp.data_status;
    if (dataFormatada.includes(' ')) {
      dataFormatada = dataFormatada.split(' ')[0];
    }
    result = result.replace(/\[DATA_ENTREGA\]/g, dataFormatada);
    result = result.replace(/\[DATA_ULTIMO_PONTO\]/g, dataFormatada);
  }

  // [CÓDIGO_REVERSA]
  if (codigoReversa) {
    result = result.replace(/\[CÓDIGO_REVERSA\]/g, codigoReversa);
  }

  // [DATA_EMISSAO]
  const hoje = new Date();
  const dataEmissao = hoje.toLocaleDateString('pt-BR');
  result = result.replace(/\[DATA_EMISSAO\]/g, dataEmissao);

  // [DATA_VALIDADE]
  if (dataVencimentoReversa) {
    const dataValidade = new Date(dataVencimentoReversa + 'T00:00:00').toLocaleDateString('pt-BR');
    result = result.replace(/\[DATA_VALIDADE\]/g, dataValidade);
  }

  // [NUMERO_OCORRENCIA]
  if (formData?.solicitacao) {
    result = result.replace(/\[NUMERO_OCORRENCIA\]/g, formData.solicitacao);
  }

  // [MOTIVO_CHAMADO]: o que está no campo Motivo do chamado (ex.: "Mala veio sem as rodinhas").
  // Usado no texto da Sestini (Adnéia, 29/10/2026). Sem Motivo, fica o colchete para a janela avisar.
  const motivoChamado = String(formData?.motivo || '').trim().replace(/[.\s]+$/, '');
  if (motivoChamado) {
    result = result.replace(/\[MOTIVO_CHAMADO\]/g, () => motivoChamado);
  }

  // [TRANSPORTADORA]
  if (pedidoErp?.transportadora) {
    result = result.replace(/\[TRANSPORTADORA\]/g, pedidoErp.transportadora);
  }

  // [STATUS_BSELLER]
  if (pedidoErp?.status_pedido) {
    result = result.replace(/\[STATUS_BSELLER\]/g, pedidoErp.status_pedido);
  }

  return result;
};

// ===== Texto montado na hora de mostrar (decisões da Adnéia, 17/10/2026) =====
// O texto guardado na tela Textos não muda. Na hora de mostrar:
// - a 1ª linha, quando é um cumprimento ("Olá,", "Olá, boa tarde.", "Boa tarde,"), vira o
//   cumprimento da hora: "Olá, Maria, boa tarde!" para o cliente, "Olá, boa tarde!" para o canal;
//   texto que começa direto (resposta no meio da conversa) fica como está;
// - "Atenciosamente!" vira "Atenciosamente,"; "Equipe de Atendimento Weconnect" vira o nome de
//   quem atende; e embaixo do nome entra "Atendimento WeConnect";
// - campo que ficou sem dado continua entre colchetes, para a janela avisar em amarelo.

export const saudacaoDaHora = (agora = new Date()) => {
  const h = agora.getHours();
  if (h >= 5 && h < 12) return 'bom dia';
  if (h >= 12 && h < 18) return 'boa tarde';
  return 'boa noite';
};

const RE_EMPRESA = /\b(LTDA|ME|EPP|EIRELI|MEI|S\/A|S\.A\.?|COMERCIO|COMÉRCIO|SERVICOS|SERVIÇOS|INDUSTRIA|INDÚSTRIA)\b/i;

export const primeiroNomeCliente = (nome) => {
  const n = String(nome || '').trim();
  if (!n || /\d/.test(n) || RE_EMPRESA.test(n)) return '';
  const p = n.split(/\s+/)[0];
  if (p.length < 2) return '';
  return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
};

export const montarCumprimento = ({ para = 'canal', nomeCliente = '', agora = new Date() } = {}) => {
  const s = saudacaoDaHora(agora);
  const nome = para === 'cliente' ? primeiroNomeCliente(nomeCliente) : '';
  return nome ? `Olá, ${nome}, ${s}!` : `Olá, ${s}!`;
};

const RE_LINHA_CUMPRIMENTO = /^\s*(ol[áa]|oi)?[\s,!.]*((bom dia|boa tarde|boa noite)[\s,!.]*)?$/i;
const RE_SO_HORA = /^\s*(bom dia|boa tarde|boa noite)[\s,!.]*$/i;
const RE_CAMPO = /\[([^\]\n]{1,40})\]/g;
const RASTREIO_GUARDADO = '\u0000RASTREIO\u0000';

// Campos que ficaram entre colchetes depois de montar (o ELO não tinha o dado).
export const camposFaltando = (texto) => {
  const vistos = [];
  String(texto || '').replace(RE_CAMPO, (_, nome) => {
    if (!vistos.includes(nome)) vistos.push(nome);
    return _;
  });
  return vistos;
};

export const montarTexto = (texto, context = {}, opcoes = {}) => {
  if (!texto) return { texto: '', cumprimento: '', comCumprimento: false };
  // marcarRastreioVazio: false onde a tela apaga o rastreio de propósito (Pendências de Transportadora)
  const { para = 'canal', agora = new Date(), marcarRastreioVazio = true } = opcoes;
  let comCumprimento = false;
  const nomeCliente = context?.pedidoErp?.nome_cliente || '';
  const cumprimento = montarCumprimento({ para, nomeCliente, agora });
  const linhas = String(texto).replace(/\r\n?/g, '\n').split('\n');
  const temAssinatura = linhas.some(l => l.includes('[ASSINATURA]'));

  // cabeça
  if (linhas.some(l => l.includes('[CUMPRIMENTO]'))) {
    for (let i = 0; i < linhas.length; i++) linhas[i] = linhas[i].replace(/\[CUMPRIMENTO\]/g, cumprimento);
    comCumprimento = true;
  } else {
    const i = linhas.findIndex(l => l.trim() !== '');
    if (i >= 0 && RE_LINHA_CUMPRIMENTO.test(linhas[i])) {
      linhas[i] = cumprimento; comCumprimento = true;
      // "Olá," com "Bom dia!" na linha de baixo: a hora já está no cumprimento novo
      const j = linhas.findIndex((l, k) => k > i && l.trim() !== '');
      if (j > i && RE_SO_HORA.test(linhas[j])) linhas.splice(j, 1);
    }
  }

  // pé
  const saida = [];
  linhas.forEach((l, i) => {
    let linha = l;
    if (/^\s*atenciosamente!\s*$/i.test(linha)) linha = 'Atenciosamente,';
    if (/^\s*equipe de atendimento weconnect\.?\s*$/i.test(linha)) {
      if (temAssinatura) return; // já tem o nome: a linha da equipe sai (o "Atendimento WeConnect" entra embaixo do nome)
      linha = '[ASSINATURA]';
    }
    saida.push(linha);
    const proxima = (linhas[i + 1] || '').trim().toLowerCase();
    if (linha.trim() === '[ASSINATURA]' && proxima !== 'atendimento weconnect') saida.push('Atendimento WeConnect');
  });
  let result = saida.join('\n');

  // rastreio vazio não some calado: fica [CÓDIGO_RASTREIO] para a janela avisar
  const { pedidoErp, awbTotal, jmsJt } = context || {};
  const temRastreio = !!(pedidoErp?.codigo_rastreio || awbTotal?.awb || jmsJt?.jms);
  if (!temRastreio && marcarRastreioVazio) result = result.replace(/\[CÓDIGO_RASTREIO\]/g, RASTREIO_GUARDADO);
  result = replaceAllPlaceholders(result, context);
  result = result.split(RASTREIO_GUARDADO).join('[CÓDIGO_RASTREIO]');
  return { texto: result, cumprimento, comCumprimento };
};

// Nome de cada campo no aviso amarelo da janela.
const NOME_DO_CAMPO = {
  'CÓDIGO_RASTREIO': 'código de rastreio (o pedido não tem)',
  'DATA_PREVISAO': 'previsão de entrega',
  'ITEM NÃO RECEBIDO': 'item não recebido',
  'DATA_SOLICITACAO': 'data da solicitação',
  'CÓDIGO_REVERSA': 'código da reversa (preencha em Dados da Reversa)',
  'DATA_VALIDADE': 'validade da reversa (preencha em Dados da Reversa)',
  'NUMERO_OCORRENCIA': 'número da ocorrência',
  'NOME_CLIENTE': 'nome do cliente', 'PRIMEIRO_NOME': 'nome do cliente', 'NOME': 'nome do cliente',
  'ENTREGA': 'número da entrega',
  'MOTIVO_CHAMADO': 'motivo do chamado (preencha o campo Motivo)',
  'PO': 'número da PO (pedido de compra ao fornecedor)',
};
export const nomeDoCampo = (campo) => NOME_DO_CAMPO[campo] || String(campo).toLowerCase().replace(/_/g, ' ');
